class ColorMetafield extends HTMLElement {
    constructor() {
        super();
        const productBtns = this.querySelectorAll(".product_btn");
        const sectionId = document.querySelector(".product-section").dataset.sectionidd;
        productBtns.forEach(productBtn => {
            const productHandle = productBtn.getAttribute("data-url");
            productBtn.addEventListener('click', this.onVariantMetafieldChange.bind(this, productHandle, sectionId));
        });
    }
    onVariantMetafieldChange(productHandle, sectionId) {
        this.currUrl = new URL(window.location);
        const urlString = this.currUrl.origin + productHandle + `?section_id=${sectionId}`;
        fetchProductDataFromMetafield(urlString);
        updateProrductUrl(productHandle);
    }
}
function updateProrductUrl(productHandle){
    const current = new URL(window.location.href);

    const size = current.searchParams.get("Size");
    const variant = current.searchParams.get("variant");

    const newUrl = new URL(productHandle, window.location.origin);

    if (size) newUrl.searchParams.set("Size", size);
    if (variant) newUrl.searchParams.set("variant", variant);

    history.replaceState(null, "", newUrl.toString());
}

async function fetchProductDataFromMetafield(urlString) {
  let response = await fetch(urlString);
  let text = await response.text();
  let htmlMarkup = new DOMParser().parseFromString(text, "text/html");

  document.querySelector(".product-section").innerHTML =
    htmlMarkup.querySelector(".product-section").innerHTML;

  theme.sections.register('product', theme.Product);
  reinitializeSizeChartJs();
  reinitializeCustomJs();

 setTimeout(() => {
  if (window.restoreSelectedSize) {
    window.restoreSelectedSize();
  }
}, 800);

}

customElements.define('color-metafield', ColorMetafield);